/**
 * Markt- und Mandanten-Ids im Klartext.
 *
 * Die Namen stammen aus `GET /orders/referrers` und `GET /webstores` (Vermessung
 * 21.09.2026). Sie stehen hier fest, weil sie sich praktisch nie ändern und die
 * Oberfläche sonst für jede Auswahlliste einen Plenty-Read bräuchte. Geschrieben
 * wird immer die Id — der Name ist nur die Beschriftung.
 *
 * ⚠ Die Nachkommastellen sind echt: 4.01 ist Amazon Germany, 102.01 Kaufland DE.
 */

/** Die Märkte, die im Bestand vorkommen, in der Reihenfolge der Plenty-Oberfläche. */
export const MARKT_NAMEN: Record<string, string> = {
  '0': 'Manuelle Eingabe',
  '1': 'WebShop',
  '148': 'WEB-API',
  '10': 'Google Adwords',
  '11': 'Google Products',
  '15': 'MS Bing',
  '18': 'Newsletter (TA)',
  '9': 'Fitballness',
  '102.01': 'Kaufland DE',
  '4.01': 'Amazon Germany',
  '4.02': 'Amazon UK',
  '4.04': 'Amazon France',
  '4.05': 'Amazon Italy',
  '4.06': 'Amazon Spain',
  '4.09': 'Amazon Netherlands',
  '4.11': 'Amazon Poland',
  '4.12': 'Amazon Sweden',
  '4.13': 'Amazon Turkey',
  '4.15': 'Amazon Belgium',
  '19': 'Teambestellung',
  '16': 'Paket',
  '14': 'Social Media PM',
  '17': 'Social Media Teamshop',
  '12': 'Google Ads Teamshop',
  '13': 'FUPA Teamshop',
  '121': 'Idealo',
  '145': 'Fruugo',
  '150': 'Check24',
  '106': 'Rakuten',
  '2': 'eBay',
};

/** Der Mandant im Klartext. `storeIdentifier`, nicht die interne id. */
export function mandantName(plentyId: number): string {
  if (plentyId === 11897) return `anstoss24.de (${plentyId})`;
  if (plentyId === 46807) return `Fussballtore.de (${plentyId})`;
  return `Mandant ${plentyId}`;
}
